module.exports = __webpack_public_path__ + "img/subscription.aee87998.svg";